import { NoteMinusIcon } from './NoteMinusIcon';

/**
 * author: Colton Wiscombe
 * id 5F9984C8-D7D1-42A8-9167-52B0B849CF22
 * name note-minus
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-minus.svg
 * tags
 */
export const PostItNoteMinusIcon = NoteMinusIcon;
export default PostItNoteMinusIcon